"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformModelFileType = void 0;
/**
 * Model file type.
 */
var SdPlatformModelFileType;
(function (SdPlatformModelFileType) {
    /**
     * Grasshopper binary file.
     */
    SdPlatformModelFileType["GH"] = "gh";
    /**
     * Grasshopper XML file.
     */
    SdPlatformModelFileType["GHX"] = "ghx";
})(SdPlatformModelFileType = exports.SdPlatformModelFileType || (exports.SdPlatformModelFileType = {}));
//# sourceMappingURL=SdPlatformModelCommons.js.map